import type { MergedApprovalItem } from './buildMergedItems';

export type ApprovalCellKind = 'signature' | 'rejected' | 'empty' | 'placeholder';

export interface ApprovalCellContent {
  kind: ApprovalCellKind;
  /** kind==='signature'일 때만 채워짐 */
  signatureData?: string;
  name: string;
}

/**
 * 결재 셀의 "무엇을 그릴지"(상태→표현 종류) 단일 SSOT.
 * 표현(마크업/스타일)은 소비처(screen/print 컴포넌트)가 kind로 결정한다.
 *
 * - rejected            → 'rejected'
 * - approved + 서명      → 'signature'
 * - approved + 무서명    → 'empty'  (OFFLINE 승인 또는 레거시 무서명 APPROVED — "인" 도장은 dead, 빈칸 처리)
 * - pending + OFFLINE    → 'empty'  (OFFLINE은 서명 칸 자체가 출력물 직접 수령)
 * - pending + ELECTRONIC → 'placeholder'  (미서명, 결재 진행 중)
 *
 * autoApprove/author 단계는 buildMergedItems가 이미 signatureData를 채워
 * 'approved'+서명으로 들어오므로 여기선 별도 분기 불필요 — status/signatureData만 보면 된다.
 */
export function resolveApprovalCellContent(
  item: MergedApprovalItem,
  isOffline: boolean,
): ApprovalCellContent {
  const name = item.name;

  // OFFLINE: 서명칸은 출력물에 직접 수령(인쇄 후 손서명) — status(승인/반려/대기) 무관 전부 빈 박스.
  // 서명 이미지가 있어도 표시하지 않는다.
  if (isOffline) {
    return { kind: 'empty', name };
  }

  if (item.status === 'rejected') {
    return { kind: 'rejected', name };
  }

  if (item.status === 'approved') {
    if (item.signatureData) {
      return { kind: 'signature', signatureData: item.signatureData, name };
    }
    // 레거시 무서명 APPROVED — 빈칸 처리 ("인" 도장은 dead)
    return { kind: 'empty', name };
  }

  // pending (ELECTRONIC)
  return { kind: 'placeholder', name };
}
